<section class="tenant-list" *appHasPermission="tenantPermissions.MODULE">
  <div class="tenant__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="tenant__header__map d-none">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="tenant__header">
    <div class="tenant__header__title">
      <h1 class="mb-0 mb-md-2">{{ tk.Management.Tenants | t }}</h1>
    </div>
    <div class="tenant__header__search">
      <div class="form-search me-3 d-none d-md-flex">
        <app-search
          [isLoading]="isLoading"
          [placeholder]="(tk.General.Search | t) || ''"
          (sendSearch)="handleSearch($event)"></app-search>
      </div>
      <ng-container *appHasPermission="tenantPermissions.CREATE">
        <app-button
          *ngIf="tenants.length"
          [id]="'add-group'"
          [label]="isMobile ? '' : (tk.User.ToAdd | t)"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addTenant()"></app-button>
      </ng-container>
    </div>
  </div>
  <div class="tenant__content">
    <app-tenant-list-content
      [groupList]="tenants"
      [pagination]="pagination"
      [loading]="loading"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"></app-tenant-list-content>
  </div>
</section>
